module.exports = __webpack_public_path__ + "static/media/cmr_6.6766568d.jpg";